import { axiosInstance } from "@/config/apiClient";
import type {
	PropertyPaginated,
	PropertyResponse,
	PropertyCreate,
	PropertyUpdate,
} from "../schemas/property";
import type { PropiedadEstado, ListParams } from "@/schemas/common";

export const propertiesApi = {
	getAll: async (params?: ListParams): Promise<PropertyPaginated> => {
		const response = await axiosInstance.get<PropertyPaginated>("/propiedad", {
			params,
		});
		return response.data;
	},

	getByEstado: async (estado: PropiedadEstado): Promise<PropertyPaginated> => {
		const response = await axiosInstance.get<PropertyPaginated>("/propiedad", {
			params: { estado },
		});
		return response.data;
	},

	getById: async (id: number): Promise<PropertyResponse> => {
		const response = await axiosInstance.get<PropertyResponse>(
			`/propiedad/${id}`,
		);
		return response.data;
	},

	create: async (data: PropertyCreate): Promise<PropertyResponse> => {
		const response = await axiosInstance.post<PropertyResponse>(
			"/propiedad",
			data,
		);
		return response.data;
	},

	update: async (
		id: number,
		data: PropertyUpdate,
	): Promise<PropertyResponse> => {
		const response = await axiosInstance.patch<PropertyResponse>(
			`/propiedad/${id}`,
			data,
		);
		return response.data;
	},

	delete: async (id: number): Promise<void> => {
		await axiosInstance.delete(`/propiedad/${id}`);
	},
};
